// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "c2f34fd0b37ca36b104f" + ".chunk.js";
};